<template>
  <div class="context">
    <p class="title">サンプルコード</p>
    <div v-for="item in items" :key="item.number" class="box">
      <p class="item subtitle">
        {{ item.subtitle }}
      </p>
      <p class="item">
        {{ item.explane }}
      </p>
      <p class="smallTitile">cURL</p>
      <v-card class="code" :text="item.curl" variant="outlined"></v-card>
      <p class="smallTitile">Python - Requests</p>
      <v-card class="code" :text="item.pythonCode" variant="outlined"></v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          number: 0,
          subtitle: "API認証",
          explane: `本APIを利用する際のアクセストークンを発行させるためのサンプルコードを以下に記載します。
          なお、アクセストークンの有効期限は300秒となります。`,
          pythonCode: `import requests

url = "https://idm.dataplatform-yamanashi.jp/auth/realms/Smartcity/protocol/openid-connect/token"

payload='grant_type=client_credentials'
headers = {
  'Authorization': 'Basic ['クライアントID:クライアント・シークレット'をBase64エンコードした文字列]',
  'Content-Type': 'application/x-www-form-urlencoded',
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)`,
          curl: `curl --location --request POST 'https://idm.dataplatform-yamanashi.jp/auth/realms/Smartcity/protocol/openid-connect/token' 
--header 'Authorization: Basic ['クライアントID:クライアント・シークレット'をBase64エンコードした文字列]' 
--header 'Content-Type: application/x-www-form-urlencoded' 
--data-urlencode 'grant_type=client_credentials'`,
        },
        {
          number: 1,
          subtitle: "APIによるデータの取得",
          explane:
            "APIを利用したデータ一覧の取得を行うためのサンプルコードを以下に記載します。",
          pythonCode: `import requests

url = "https://api.dataplatform-yamanashi.jp/ngsi/v2/entities"

payload={}
headers = {
  'Authorization': 'Bearer [認証して取得したアクセストークン]'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)`,
          curl: `curl --location --request GET 'https://api.dataplatform-yamanashi.jp/ngsi/v2/entities' 
--header 'Authorization: Bearer [認証して取得したアクセストークン]'`,
        },
        {
          number: 2,
          subtitle: "統計表名「市町村別国調人口・世帯数」のデータ取得",
          explane: `本開発者ポータルの"提供データ"の項目にて「市町村別国調人口・世帯数」の統計表番号を確認の上、
            APIを利用してデータの取得を行うためのサンプルコードを以下に記載します。
            その際に、取得するエンティティ数を10に制限します。`,
          pythonCode: `import requests

url = "https://api.dataplatform-yamanashi.jp/ngsi/v2/entities?limit=10&idPattern=.*EDAA02000.*"

payload={}
headers = {
  'Authorization': 'Bearer [認証して取得したアクセストークン]'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)`,
          curl: `curl --location --request GET 'https://api.dataplatform-yamanashi.jp/ngsi/v2/entities?limit=10&idPattern=.*EDAA02000.*' 
--header 'Authorization: Bearer [認証して取得したアクセストークン]'`,
        },
      ],
    };
  },
};
</script>

<style scoped>
.context {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  font-size: 2vw;
  font-weight: 700;
  position: relative;
  margin-bottom: 4%;
}

.title::before {
  content: "";
  position: absolute;
  height: 70%;
  aspect-ratio: 2/10;
  background-color: #85bff2;
  left: -1.5vw;
  top: 0;
  bottom: 0;
  margin: auto 0;
}

.item {
  font-size: 1.4vw;
  white-space: pre-line;
}

.box {
  margin-bottom: 4vw;
}

.subtitle {
  font-weight: 700;
}

.smallTitile {
  font-weight: 500;
  font-size: 1.2vw;
  margin-bottom: 0.5vw;
  margin-top: 1vw;
}

.content {
  padding: 0 0 0 4%;
}

.code {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
